import React, {FC} from 'react';

import {Renderer} from '../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {
  BoxedInput,
  BoxedInputInheritableProps,
} from '../../../../libs/shared/ui/src/components/boxedInputs/boxedInput';
import {ContentEditableProps} from '../editor/contentEditable';
import {BoxedInputContentEditable} from './boxedInputContentEditable';

/*
 * Props.
 */

export interface ContentEditableBoxProps extends ContentEditableProps, BoxedInputInheritableProps {
  renderPlaceholder?: Renderer;
  maxHeight?: number;
}

/*
 * Component.
 */

export const ContentEditableBox: FC<ContentEditableBoxProps> = (props) => (
  <BoxedInput {...props}>
    {(childProps) => <BoxedInputContentEditable {...childProps} {...props} />}
  </BoxedInput>
);
